// Mock data for Litoral Norte website

export const companyInfo = {
  name: "Litoral Norte",
  fullName: "Litoral Norte - Transporte Rodoviário de Passageiros, Lda",
  founded: "2003-03-03",
  fleetSize: 24,
  phone: "252 692 266",
  email: "geral@litoralnorte.pt",
  address: {
    street: "Centro Comercial Premar, Av. Mouzinho de Albuquerque",
    lojas: "Lojas 13-15",
    postal: "4490-409",
    city: "Póvoa de Varzim",
    country: "Portugal"
  },
  hours: {
    weekdays: "09h às 18h",
    saturday: "Fechado",
    sunday: "Fechado"
  },
  coordinates: {
    lat: 41.38273,
    lng: -8.75998
  }
};

export const unirLines = [
  {
    number: "3001",
    name: "Póvoa de Varzim (Paranho) - Vila do Conde (Estação Portas Fronhas)",
    route: "via Travassos",
    schedules: [
      { departure: "07:00", arrival: "07:30", days: "Dias úteis" },
      { departure: "08:30", arrival: "09:00", days: "Dias úteis" },
      { departure: "12:00", arrival: "12:30", days: "Dias úteis" },
      { departure: "17:00", arrival: "17:30", days: "Dias úteis" },
      { departure: "19:00", arrival: "19:30", days: "Dias úteis" },
      { departure: "09:00", arrival: "09:30", days: "Sábados" },
      { departure: "14:00", arrival: "14:30", days: "Sábados" },
      { departure: "18:00", arrival: "18:30", days: "Sábados" },
      { departure: "10:00", arrival: "10:30", days: "Domingos e Feriados" },
      { departure: "16:00", arrival: "16:30", days: "Domingos e Feriados" }
    ]
  },
  {
    number: "3002",
    name: "Póvoa de Varzim (Torrinha) - Vila do Conde (Estação Portas Fronhas)",
    route: "",
    schedules: [
      { departure: "07:15", arrival: "07:40", days: "Dias úteis" },
      { departure: "08:45", arrival: "09:10", days: "Dias úteis" },
      { departure: "13:00", arrival: "13:25", days: "Dias úteis" },
      { departure: "17:30", arrival: "17:55", days: "Dias úteis" },
      { departure: "09:30", arrival: "09:55", days: "Sábados" },
      { departure: "15:00", arrival: "15:25", days: "Sábados" },
      { departure: "10:30", arrival: "10:55", days: "Domingos e Feriados" }
    ]
  },
  {
    number: "3003",
    name: "Póvoa de Varzim - Balazar",
    route: "",
    schedules: [
      { departure: "07:30", arrival: "08:00", days: "Dias úteis" },
      { departure: "12:30", arrival: "13:00", days: "Dias úteis" },
      { departure: "17:45", arrival: "18:15", days: "Dias úteis" },
      { departure: "10:00", arrival: "10:30", days: "Sábados" },
      { departure: "15:30", arrival: "16:00", days: "Sábados" }
    ]
  },
  {
    number: "3004",
    name: "Póvoa de Varzim - Portas Fronhas (Metro)",
    route: "",
    schedules: [
      { departure: "06:45", arrival: "07:15", days: "Dias úteis" },
      { departure: "08:00", arrival: "08:30", days: "Dias úteis" },
      { departure: "12:15", arrival: "12:45", days: "Dias úteis" },
      { departure: "17:15", arrival: "17:45", days: "Dias úteis" },
      { departure: "19:15", arrival: "19:45", days: "Dias úteis" },
      { departure: "08:30", arrival: "09:00", days: "Sábados" },
      { departure: "13:00", arrival: "13:30", days: "Sábados" },
      { departure: "18:00", arrival: "18:30", days: "Sábados" },
      { departure: "09:30", arrival: "10:00", days: "Domingos e Feriados" },
      { departure: "17:00", arrival: "17:30", days: "Domingos e Feriados" }
    ]
  },
  {
    number: "3006",
    name: "Esposende (CCT) - Vila do Conde (Estação Portas Fronhas)",
    route: "via Aguçadora",
    schedules: [
      { departure: "07:00", arrival: "08:00", days: "Dias úteis" },
      { departure: "13:00", arrival: "14:00", days: "Dias úteis" },
      { departure: "18:00", arrival: "19:00", days: "Dias úteis" },
      { departure: "09:00", arrival: "10:00", days: "Sábados" },
      { departure: "15:00", arrival: "16:00", days: "Sábados" },
      { departure: "11:00", arrival: "12:00", days: "Domingos e Feriados" }
    ]
  },
  {
    number: "3301",
    name: "Póvoa de Varzim (Aguçadoura) - Vila do Conde (Estação)",
    route: "",
    schedules: [
      { departure: "07:20", arrival: "07:50", days: "Dias úteis" },
      { departure: "12:45", arrival: "13:15", days: "Dias úteis" },
      { departure: "17:50", arrival: "18:20", days: "Dias úteis" },
      { departure: "10:00", arrival: "10:30", days: "Sábados" },
      { departure: "16:00", arrival: "16:30", days: "Sábados" }
    ]
  },
  {
    number: "3302",
    name: "Póvoa de Varzim (Zona Industrial Amorim) - Vila do Conde (Estação Varziela)",
    route: "",
    schedules: [
      { departure: "06:30", arrival: "07:00", days: "Dias úteis" },
      { departure: "08:15", arrival: "08:45", days: "Dias úteis" },
      { departure: "12:30", arrival: "13:00", days: "Dias úteis" },
      { departure: "17:00", arrival: "17:30", days: "Dias úteis" },
      { departure: "19:00", arrival: "19:30", days: "Dias úteis" },
      { departure: "08:00", arrival: "08:30", days: "Sábados" },
      { departure: "14:00", arrival: "14:30", days: "Sábados" },
      { departure: "18:30", arrival: "19:00", days: "Sábados" },
      { departure: "10:00", arrival: "10:30", days: "Domingos e Feriados" },
      { departure: "17:30", arrival: "18:00", days: "Domingos e Feriados" }
    ]
  }
];


export const services = [
{
  id: "unir",
  title: "Carreiras UNIR",
  description: "Serviço regular de transporte público na zona da Póvoa de Varzim e Vila do Conde. Operamos 7 linhas do Lote 3 da rede UNIR, garantindo mobilidade diária para a população local.",
  icon: "Bus",
  features: [
  "7 linhas em operação",
  "Horários regulares",
  "Ligações entre Póvoa e Vila do Conde",
  "Tarifário UNIR"]

},
{
  id: "cim-cavado",
  title: "Carreiras CIM Cávado",
  description: "Serviço de transporte público da Comunidade Intermunicipal do Cávado. Operamos a linha Póvoa de Varzim - Barcelos, conectando as duas cidades.",
  icon: "Bus",
  features: [
  "Linha Póvoa - Barcelos",
  "Ligação intermunicipal",
  "Horários regulares",
  "Tarifário CIM Cávado"]

},
{
  id: "regular",
  title: "Alugueres Ocasionais",
  description: "Aluguer de servi\xE7os regulares para escolas e empresas. Transporte confort\xE1vel e seguro com motoristas experientes.",
  icon: "Calendar",
  features: [
  "Frota moderna de 24 autocarros",
  "Motoristas profissionais",
  "Flexibilidade de horários",
  "Preços competitivos"]

},
{
  id: "specialized",
  title: "Alugueres Especializados",
  description: "Serviços especializados para empresas, escolas e instituições. Transporte de colaboradores, excursões escolares e eventos especiais.",
  icon: "Briefcase",
  features: [
  "Contratos personalizados",
  "Serviço dedicado",
  "Rotas ajustadas às necessidades",
  "Preços competitivos"]

},
{
  id: "tourism",
  title: "Turismo",
  description: "Viaje connosco! Oferecemos servi\xE7os de turismo com autocarros confort\xE1veis para grupos, excurs\xF5es e viagens organizadas, tanto em Portugal como noutros destinos europeus.",
  icon: "MapPin",
  features: [
  "Viagens personalizadas",
  "Autocarros confortáveis",
  "Destinos nacionais e internacionais",
  "Preços competitivos"]

}];


export const testimonials = [
{
  id: 1,
  name: "Maria Silva",
  company: "Escola Secundária",
  text: "Excelente serviço! Utilizamos a Litoral Norte para as nossas excursões escolares há vários anos. Sempre pontuais, seguros e com motoristas muito profissionais.",
  rating: 5
},
{
  id: 2,
  name: "João Santos",
  company: "Empresa Local",
  text: "Contratamos os serviços da Litoral Norte para transporte dos nossos colaboradores. Muito satisfeitos com a qualidade do serviço e a simpatia de toda a equipa.",
  rating: 5
},
{
  id: 3,
  name: "Ana Rodrigues",
  company: "Grupo de Turismo",
  text: "Fizemos uma viagem pelo norte de Portugal com a Litoral Norte. Autocarros modernos e confortáveis, motorista excelente. Recomendamos vivamente!",
  rating: 5
},
{
  id: 4,
  name: "Carlos Pereira",
  company: "Associação Cultural",
  text: "Utilizamos regularmente os serviços UNIR para as nossas deslocações diárias. Horários cumpridos e bom atendimento. Um serviço essencial para a comunidade.",
  rating: 5
}];


export const gallery = [
  // Alternando interior e exterior
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_povoa-transport/artifacts/idt4wsmj_IMG_0605%20copy.JPEG",
    title: "Autocarro Litoral Branco",
    category: "fleet,tourism"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_povoa-transport/artifacts/vy7nh1k4_WhatsApp%20Image%202026-04-08%20at%2017.30.57.jpeg",
    title: "Interior Turismo - Bancos Vermelhos",
    category: "tourism"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_povoa-transport/artifacts/ys9q504c_WhatsApp%20Image%202026-04-08%20at%2014.12.24.jpeg",
    title: "Autocarro UNIR",
    category: "fleet,unir"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_povoa-transport/artifacts/i83s109l_WhatsApp%20Image%202026-04-08%20at%2017.31.31.jpeg",
    title: "Interior UNIR - Zona Motorista",
    category: "unir"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_povoa-transport/artifacts/xgcpvkn8_IMG_0617.JPEG",
    title: "Autocarro Litoral Branco Premium",
    category: "fleet,tourism"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_povoa-transport/artifacts/3b1d0ym9_IMG_0587.JPEG",
    title: "Interior Turismo - Bancos Pretos",
    category: "tourism"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_povoa-transport/artifacts/sp7sw4to_IMG_0613.JPEG",
    title: "Autocarro Litoral Preto",
    category: "fleet,tourism"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_povoa-transport/artifacts/hyv9ci7r_IMG_0609.JPEG",
    title: "Interior Turismo Premium",
    category: "tourism"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_povoa-transport/artifacts/yrfrm3aa_IMG_0621.JPEG",
    title: "Interior UNIR - Azul",
    category: "unir"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_povoa-transport/artifacts/dcdqx86z_WhatsApp%20Image%202026-04-08%20at%2017.31.08.jpeg",
    title: "Interior UNIR - Conforto",
    category: "unir"
  },
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_povoa-transport/artifacts/mxdhfqhc_WhatsApp%20Image%202026-04-08%20at%2017.31.30.jpeg",
    title: "Interior UNIR - Espaçoso",
    category: "unir"
  },
  {
    id: 12,
    url: "https://customer-assets.emergentagent.com/job_povoa-transport/artifacts/0s27eeim_IMG_0150%5B15%5D.jpg.jpeg",
    title: "Interior UNIR Premium - Chão Madeira",
    category: "unir"
  },
  {
    id: 13,
    url: "https://customer-assets.emergentagent.com/job_povoa-transport/artifacts/3qwoill0_IMG_0156.jpg.jpeg",
    title: "Autocarro UNIR Moderno",
    category: "fleet,unir"
  },
  {
    id: 14,
    url: "https://customer-assets.emergentagent.com/job_povoa-transport/artifacts/88o8d6ro_IMG_0160.jpg.jpeg",
    title: "Autocarro UNIR - Design Colorido",
    category: "fleet,unir"
  },
  {
    id: 15,
    url: "https://customer-assets.emergentagent.com/job_povoa-transport/artifacts/6eqlh6kg_IMG_0150%5B15%5D.jpg.jpeg",
    title: "Interior UNIR - Chão Madeira Nobre",
    category: "unir"
  }
];


export const stats = [
{
  number: "24",
  label: "Autocarros",
  suffix: ""
},
{
  number: "23",
  label: "Anos de Experiência",
  suffix: "+"
},
{
  number: "7",
  label: "Linhas UNIR",
  suffix: ""
},
{
  number: "1000",
  label: "Clientes Satisfeitos",
  suffix: "+"
}];